import React from "react";
import { useNavigate } from "react-router-dom";

const Permissonheader = ({ setAdminShow }) => {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-50 ">
      <nav className="bg-brand-500 rounded-t-lg  text-white p-4 shadow-lg flex justify-between">
        <div className="flex space-x-8">
          <button
            onClick={() => setAdminShow(true)}
            className="text-lg font-semibold  "
          >
            Admin App
          </button>
          <button
            onClick={() => setAdminShow(false)}
            className="text-lg font-semibold  "
          >
            Practitioner app
          </button>
        </div>
        <button
          className="text-lg font-semibold"
          onClick={() => navigate("/iam/roles")}
        >
          Back
        </button>
      </nav>
    </div>
  );
};

export default Permissonheader;
